import { supabase } from './supabase';

// 헬스장 활성 공지 조회 (오늘 날짜 기준)
export async function getActiveGymNotices(gymId) {
  const today = new Date().toISOString().split('T')[0];
  const { data, error } = await supabase
    .from('gym_notices')
    .select('*')
    .eq('gym_id', gymId)
    .lte('starts_at', today)
    .or(`ends_at.is.null,ends_at.gte.${today}`)
    .order('created_at', { ascending: false });
  if (error) return [];
  return data || [];
}

// 헬스장 전체 공지 조회 (대표자용)
export async function getAllGymNotices(gymId) {
  const { data, error } = await supabase
    .from('gym_notices')
    .select('*')
    .eq('gym_id', gymId)
    .order('starts_at', { ascending: false });
  if (error) return [];
  return data || [];
}

// 공지 생성
export async function createGymNotice({ gymId, title, content, startsAt, endsAt }) {
  const { error } = await supabase.from('gym_notices').insert({
    gym_id: gymId,
    title,
    content: content || null,
    starts_at: startsAt,
    ends_at: endsAt || null,
  });
  return { error };
}

// 공지 수정
export async function updateGymNotice(id, { title, content, startsAt, endsAt }) {
  const patch = {};
  if (title !== undefined) patch.title = title;
  if (content !== undefined) patch.content = content || null;
  if (startsAt !== undefined) patch.starts_at = startsAt;
  if (endsAt !== undefined) patch.ends_at = endsAt || null;
  const { error } = await supabase.from('gym_notices').update(patch).eq('id', id);
  return { error };
}

// 공지 삭제
export async function deleteGymNotice(id) {
  const { error } = await supabase.from('gym_notices').delete().eq('id', id);
  return { error };
}
